import { render, staticRenderFns } from "./CuentaCobroPage.vue?vue&type=template&id=23a367c2"
import script from "./CuentaCobroPage.js?vue&type=script&lang=js&external"
export * from "./CuentaCobroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports